export default __webpack_public_path__ + "static/slide-02-95875efce6c3f7692a7333890f9be6d4.png";